<template>
  <div class="d-inline-block">
    <div :class="oneLine ? 'col-6' : 'col-12'">
      <span>
        {{ value }}
      </span>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  props: ["value", "valueStyle", "oneLine", "divValueStyle"],
})
export default class OnlyValue extends Vue {
  value?: string;
  valueStyle?: any;
  divValueStyle?: any;
  oneLine?: boolean;
}
</script>
